export default "__VITE_ASSET__BYz7QxC5__"